import type { RoutePath } from './Route.types.ts';
import { shellPadding } from '../components/technical/PageShell/PageShell.utils.ts';
import { Box } from '@mui/joy';

export const NotFoundRoute: RoutePath = {
  path: '*',
  element: <Box padding={shellPadding}>Path does not exist</Box>,
};
